export async function claimRewardAndIncreaseStakeToTown(params) {
    const { spaceDapp, smartAccount, fnArgs } = params;
    const { amount, depositId, delegatee, beneficiary, signer } = fnArgs;
    if (!spaceDapp?.townsToken || !spaceDapp.config.addresses.utils.towns) {
        throw new Error('spaceDapp.townsToken is required for stakeToTowns operation.');
    }
    const townsAddress = spaceDapp.config.addresses.utils.towns;
    const rewardsAddress = spaceDapp.config.addresses.baseRegistry;
    if (!townsAddress || !rewardsAddress) {
        throw new Error('Towns and Rewards addresses are required for stakeToTowns operation.');
    }
    return smartAccount.sendUserOp({
        toAddress: [rewardsAddress, townsAddress, rewardsAddress],
        callData: [
            spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('claimReward', [beneficiary, beneficiary]),
            spaceDapp.townsToken?.interface.encodeFunctionData('approve', [rewardsAddress, amount]),
            spaceDapp.baseRegistry.rewardsDistributionV2.interface.encodeFunctionData('increaseStake', [depositId, amount]),
        ],
        signer,
        spaceId: delegatee,
        functionHashForPaymasterProxy: 'unsponsored',
    });
}
